import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, X } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-242">
      <motion.div initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 to-pink-600 text-white shadow-md" data-id="element-243">
        <div className="container mx-auto px-3 py-1" data-id="element-244">
          <div className="flex items-center justify-center gap-2 text-xs sm:text-sm relative" data-id="element-245">
            <Clock className="w-3 h-3 animate-pulse flex-shrink-0" data-id="element-246" />
            <span className="font-semibold tracking-tight" data-id="element-247">
              Oferta termina en
            </span>
            <span className="font-mono font-bold bg-white/20 px-2 py-0.5 rounded" data-id="element-248">
              {String(minutes).padStart(2, '0')}:
              {String(seconds).padStart(2, '0')}
            </span>
            <button onClick={() => setIsVisible(false)} className="absolute right-0 text-white/70 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-249">
              <X className="w-3.5 h-3.5" data-id="element-250" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}